import { Box } from '@mui/material'

interface ProportionBarProps {
  percent: number      // this row's share of the whole
  maxPercent: number   // largest share in the set, for normalising bar width
  color: string
}

// The 8px rounded proportional track used by the executive bar charts.
// Extracted so rich legend widgets can drop a bar into their custom rows.
export default function ProportionBar({ percent, maxPercent, color }: ProportionBarProps) {
  const safeMax = maxPercent > 0 ? maxPercent : 1
  return (
    <Box
      sx={{
        width: '100%',
        height: 8,
        backgroundColor: '#f0f0f0',
        borderRadius: 1,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          width: `${(percent / safeMax) * 100}%`,
          height: '100%',
          backgroundColor: color,
          borderRadius: 1,
          transition: 'width 200ms ease',
        }}
      />
    </Box>
  )
}
